import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

console.log('%c[+0ms] [INIT] index.js executing — React mounting', 'color:#b8944a;font-weight:bold');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

console.log('%c[+0ms] [INIT] root.render() called', 'color:#b8944a;font-weight:bold');
